import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'

import { VasenValikkoService } from 'app/_jaettu-angular/service/vasen-valikko.service'
import { KirjautunutKayttajaService } from '../_angular/service/kirjautunut-kayttaja.service'

import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

@Component({
  templateUrl: './loggedout.component.html',
  styleUrls: ['./loggedout.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoggedOutComponent implements OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>()

  commonError: string = null
  naytaSsoLogin: boolean = false

  constructor(
    private _router: Router,
    private _kirjautunutKayttajaService: KirjautunutKayttajaService,
    private _vasenValikkoService: VasenValikkoService,
  ) {
    setTimeout(() => {
      this._vasenValikkoService.paivitaAuki(false)
    }, 5)
    this._kirjautunutKayttajaService.kirjanpitajanTiedotObservable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(kirjanpitajanTiedot => {
      if (kirjanpitajanTiedot) {
        this._vasenValikkoService.paivitaAuki(true)
        this._router.navigate(['/'])
      }
    })
  }

  peruuta() {
    this.naytaSsoLogin = false
    this._kirjautunutKayttajaService.logoutImmediate()
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next()
    this.ngUnsubscribe.complete()
  }

  getYear(): string {
    return new Date().getFullYear() + ''
  }
}
